import React, { useState } from 'react';
import { Tabs } from 'antd';
import PageLayout from '../components/layout/PageLayout';
import StcStatsTab from './StcStatsTab';
import CecEquipmentTab from './CecEquipmentTab';
import RetailPriceTrendingTab from './RetailPriceTrendingTab';

export default function MarketIntelligence() {
  const [activeTab, setActiveTab] = useState('stc');

  return (
    <PageLayout>
      <div className="page-header">
        <h1>Market Intelligence</h1>
        <p>Industry registration volumes and approved-equipment reference data</p>
      </div>
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        destroyInactiveTabPane={false}
        items={[
          { key: 'stc', label: 'STC Stats', children: <StcStatsTab /> },
          { key: 'cec', label: 'CEC Approved Equipment', children: <CecEquipmentTab /> },
          // Scrapes on open, so only mount it when the tab is actually selected.
          { key: 'retail', label: 'Retail Price Trending',
            children: activeTab === 'retail' ? <RetailPriceTrendingTab /> : null },
        ]}
      />
    </PageLayout>
  );
}
